import { ColorFormItem } from '../ColorFormItem/ColorFormItem';
import { MessageFormItem } from '../MessageFormItem/MessageFormItem';

export const PrintEditForm = () => (
  <>
    <ColorFormItem />
    <MessageFormItem />
  </>
);
